import React, { PropTypes } from 'react';
import CircularProgress from 'material-ui/CircularProgress';

class LoadingSpinner extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    overlay: PropTypes.bool
  };

  getStyle() {
    return {
      container: {
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        minHeight: this.props.show ? 'calc(100vh - 120px)' : undefined,
      }
    };
  }

  render() {
    let { show, overlay } = this.props;
    let style = this.getStyle();

    return <div style={overlay && show ? {
      pointerEvents: 'none',
      ...style.container
    } : style.container}>
      {show && <CircularProgress style={{ zIndex: 1000, position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} size={60} />}
      <div style={show ? {opacity: 0.5} : {}}>{ !!(!show || overlay) && this.props.children}</div>
      </div>
  }
}

export default LoadingSpinner;




// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.jsx